<template>
    <v-select v-model="semesterSelected"
              :items="semesters()"
              chips
              class="ml-4"
              deletable-chips
              item-text="value"
              item-value="key"
              menu-props="auto"
              multiple
              placeholder="Wszystkie semestry"
              single-line
    >
    </v-select>
</template>
<script>
import moment from "moment";
import {mapActions, mapGetters} from "vuex";

export default {
    name: 'MultiSelectSemesters',
    methods: {
      ...mapActions({
        setMultiSemesterSelected: 'setMultiSemesterSelected',
      }),
      semesters () {
        moment.locale('pl');
        const semesters = [];
        semesters.push({ 'key': '', 'value': 'Wszystkie semestry'})
        const dateStart = moment("2020-10-01");
        const dateEnd = moment().add(7, 'month');
        let i = 0;
        while (dateEnd.diff(dateStart, 'semesters') >= 0) {
          semesters.push({ 'key': dateStart.format('YYYY-MM-DD'), 'value': dateStart.locale('pl').format('MMMM YYYY')});
          if (i++ % 2 == 0) {
            dateStart.add(5, 'month')
          } else {
            dateStart.add(7, 'month')
          }
        }
        return semesters.reverse()
      },
    },
    mounted() {
    },
    computed: {
      ...mapGetters({
        semesterSelectedFromStore: 'multiSemesterSelected',
      }),
      semesterSelected: {
        get() {
          return this.semesterSelectedFromStore
        },
        set(value){
          this.$emit('semesterChanged', value)
          return this.setMultiSemesterSelected(value)
        }
      },
    }
  }
</script>
